<template>
    <div>
        <!-- 头部菜单 -->
        <div class="contain-right-menu">
            <div class="contain-right-menu-box" v-for="(item,index) in menu" :key="index" @click="goMenu(index)">
                <div class="contain-right-menu-box-left">
                    <div class="balance">{{item.title}}</div>
                    <div class="balance-number">{{item.money}}</div>
                    <div class="go-recharge">
                        <span>{{item.type}}</span>
                        <img src="../../../assets/image/blueLeft.png" alt="">
                    </div>
                </div>
                <img :src="item.icon" alt="">
            </div>
        </div>
        <router-view></router-view>
         <!-- 余额 -->
        <el-dialog
            title="余额充值"
            custom-class="dialog"
            :visible.sync="balance"
            width="22%"
            >
            <div class="balance">
                <div class="balance-num">
                    <div class="balance-num-item">
                        <div>我的余额</div>
                        <div>¥680.00</div>
                    </div>
                </div>
                <div class="input">
                    <el-input v-model="input" placeholder="输入充值的金额"></el-input>
                </div>
                <!-- 选择充值方式 -->
                <div class="recharge-type">
                    <div class="recharge-type-title">选择支付方式</div>
                    <!-- 支付宝 -->
                    <div class="recharge-type-box" :class="active==index ? 'active':''" v-for="(item,index) in rechargeList" :key="index" @click="check(index)">
                        <div class="recharge-type-box-left">
                            <img :src="item.icon" alt="">
                            <span>{{item.name}}</span>
                        </div>
                        <img v-if="active==index" :src="item.isActive" alt="">
                    </div>
                </div>
                <div class="recharge-btn">
                    <el-button type="primary" @click="balance = false">确 定</el-button>
                </div>
            </div>
        </el-dialog>

                 <!-- 套餐 -->
         <div class="packages"> 
            <el-dialog
                custom-class="dialog"
                :visible.sync="packages"
                width="600px"
                center>
                <!-- 头部title -->
                <template slot="title">
                    <div class="dialog-head">
                        <img src="../../../assets/logo.png" alt="">
                        <span>菜鸟驿站的鸟</span>
                    </div>
                </template>
                <!-- 内容 -->
                <div class="dialog-content">
                    <!-- 类型 -->
                    <div class="dialog-tab">
                        <div class="dialog-content-tab" :class="tabActive==index ? 'tabActive':''" v-for="(item,index) in tabList" :key="index" @click="clickTab(index)">
                            <div class="dialog-content-tab-box">{{item.title}}</div>
                        </div>
                    </div>
                    <!-- 按时付费 -->
                    <div class="dialog-active-one" v-if="tabActive==0">
                        <!-- 详细信息 -->
                        <div class="dialog-box">
                            <div class="dialog-box-item" v-for="(item,index) in 3" :key="index">
                                <div>产品名称：</div>
                                <div>电竞课程网课</div>
                            </div>
                        </div>
                        <!-- 是否授权 -->
                        <div class="dialog-isok" @click="isok=!isok">
                            <img v-if="isok" src="../../../assets/image/active.png" alt="">
                            <div>我已阅读并同意</div>
                            <span>《用户付费协议》</span>
                        </div>
                        <!-- 开通 -->
                        <div class="dialog-btn">
                            <el-button type="primary" @click="packages = false">开通服务</el-button>
                        </div>
                    </div>
                    <!-- 套餐包 -->
                    <div class="dialog-active-two" v-else>
                        <div class="dialog-check-packages">
                            <!-- 套餐 -->
                            <div class="dialog-check-packages-content" :class="isPackage==index ? 'isPackage':''" v-for="(item,index) in 3" :key="index" @click="activePackage(index)">
                                <div class="dialog-check-packages-box">
                                    <div>套餐一</div>
                                    <div><span>￥</span><span>96</span></div>
                                    <div>15个课时</div>
                                </div>
                                <div class="is-recommend" v-if="index==1">推荐</div>
                            </div>
                        </div>
                        <!-- 支付title -->
                        <div class="dialog-check-title">支付方式</div>
                        <!-- 选择支付 -->
                        <div class="dialog-check-pay">
                            <div class="dialog-check-pay-left">
                                <div class="dialog-check-pay-left-box" :style="{background:payActive==index?'#FFFFFF':''}" v-for="(item,index) in payList" :key="index" @click="clickPay(index)">
                                    <img :src="item.icon" alt="">
                                    <span>{{item.title}}</span>
                                </div>
                            </div>
                            <div class="dialog-check-pay-right">
                                <div class="dialog-check-pay-right-pay" v-if="payActive==0">
                                    <img src="../../../assets/logo.png" alt="">
                                    <div class="dialog-check-pay-right-pay-phone">
                                        <span>支付金额：</span>
                                        <span>99</span>
                                        <span>元</span>
                                    </div>
                                </div>
                                <div class="dialog-check-pay-right-pay" v-else-if="payActive==1">
                                    <img src="../../../assets/logo.png" alt="">
                                    <div class="dialog-check-pay-right-pay-phone">
                                        <span>支付金额：</span>
                                        <span>99</span>
                                        <span>元</span>
                                    </div>
                                </div>
                                <div class="dialog-check-pay-right-balance" v-else>
                                    <div>当前钱包余额：390元</div>
                                    <div>
                                        <span>支付金额：</span>
                                        <span>99</span>
                                        <span>元</span>
                                    </div>
                                    <el-button type="primary">立即支付</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog>
         </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            payActive:0,
            isPackage:0,
            isok:false,
            tabActive:0,
            active:0,
            balance:false,
            packages:false,
            payList:[
                {
                    title:'支付宝',
                    icon:require("../../../assets/image/Alipay.png")
                },
                {
                    title:'微信',
                    icon:require("../../../assets/image/WeChat.png")
                },
                {
                    title:'余额',
                    icon:require("../../../assets/image/balance-pay.png")
                }
            ],
            tabList:[
                {
                    title:"按时付费"
                },
                {
                    title:'套餐包'
                }
            ],
            rechargeList:[
                {
                    name:'支付宝',
                    icon:require("../../../assets/image/Alipay.png"),
                    isActive:require("../../../assets/image/active.png")
                },
                {
                    name:'微信',
                    icon:require("../../../assets/image/WeChat.png"),
                    isActive:require("../../../assets/image/active.png")
                }
            ],
             menu:[
                {
                    title:'可用余额（元）',
                    money:'934.00',
                    type:'去充值',
                    icon:require("../../../assets/image/balance.png")
                },
                {
                    title:'套餐到期时间',
                    money:'2021-01-21',
                    type:'去续费',
                    icon:require("../../../assets/image/wallet-date.png")
                },
                {
                    title:'本月消费（元）',
                    money:'93.00',
                    type:'查看记录',
                    icon:require("../../../assets/image/consumption.png")
                },
                {
                    title:'本月订单',
                    money:'934.00',
                    type:'查看记录',
                    icon:require("../../../assets/image/order.png")
                },
            ]
        }
    },
    methods:{
        clickPay(index){
            this.payActive=index
        },
        activePackage(index){
            this.isPackage=index
        },
        check(index){
            this.active=index
        },
        goMenu(index){
            if(index==0){
                this.balance=true
            }else if(index==1){
                this.packages=true
            }else if(index==2){
                this.$router.push("/mine/my_wallet/consumption")
            }else{
                this.$router.push("/mine/my_wallet/order")
            }
        },
        sendForum(){
            this.$router.push("/forum/sendForum")
        },
        clickTab(index){
            this.tabActive=index;
        },
    }
}
</script>
<style lang="scss">
.packages{
    .el-dialog__header{
        background: #3D7EFF;
        border-radius: 16px 16px 0px 0px;
    }
    .el-dialog__headerbtn .el-dialog__close {
        size: 26px;
        color: #FFFFFF;
    }
    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 0 0 20px 0;
    }
    .dialog-head{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        img{
            width: 35px;
            height: 35px;
            border-radius: 50%;
        }
        span{
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            margin-left: 10px;
        }
    }
    .dialog-content{
        .dialog-tab{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            margin-bottom: 35px;
            .dialog-content-tab{
                padding: 18px 0;
                width: 50%;
                .dialog-content-tab-box{
                    text-align: center;
                    font-size: 22px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #1E2134;
                }
            }
            .tabActive{
                background: #F9FAFD;
            }
        }
        .dialog-active-one{
            .dialog-box{
                padding: 0 55px;
                .dialog-box-item{
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    margin-top: 30px;
                    div{
                        &:nth-child(1){
                            font-size: 22px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #858585;
                        }
                        &:nth-child(2){
                            font-size: 22px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #1E2134;
                        }
                    }
                }
            }
            .dialog-isok{
                cursor: pointer;
                margin-top: 127px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                img{
                    width: 18px;
                    height: 18px;
                }
                div{
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #1E2134;
                    margin-left: 10px;
                }
                span{
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #3D7EFF;
                }
            }
            .dialog-btn{
                margin-top: 25px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                .el-button{
                    width: 336px;
                    height: 50px;
                }
            }
        }
        .dialog-active-two{
            padding: 0 45px;
            .dialog-check-packages{
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .isPackage{
                    border: 2px solid #3D7EFF;
                    border-radius: 12px;
                }
                .dialog-check-packages-content{
                    width: 30%;
                    position: relative;
                    .dialog-check-packages-box{
                        height: 140px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        background: #FFFFFF;
                        box-shadow: 0px 2px 17px 2px rgba(204, 204, 204, 0.16);
                        border-radius: 12px;
                        border: 1px solid #F1F1F1;
                        div{
                            &:nth-child(1){
                                font-size: 18px;
                                font-family: PingFangSC-Medium, PingFang SC;
                                font-weight: 500;
                                color: #1E2134;
                            }
                            &:nth-child(2){
                                margin: 11px 0;
                                display: flex;
                                flex-direction: row;
                                justify-content: flex-start;
                                align-items: center;
                                span{
                                    &:nth-child(1){
                                        font-size: 8px;
                                        font-family: SFProDisplay-Semibold, SFProDisplay;
                                        font-weight: 600;
                                        color: #F24342;
                                    }
                                    &:nth-child(2){
                                        font-size: 24px;
                                        font-family: SFProDisplay-Semibold, SFProDisplay;
                                        font-weight: 600;
                                        color: #F24342;
                                    }
                                }
                            }
                            &:nth-child(3){
                                font-size: 16px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #858585;
                            }
                        }
                    }
                    .is-recommend{
                        text-align: center;
                        width: 66px;
                        height: 24px;
                        background: linear-gradient(221deg, #FF8282 0%, #F24342 100%);
                        border-radius: 10px 2px 10px 0px;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 24px;
                        position: absolute;
                        top: -10px;
                    }
                }
            }
            .dialog-check-title{
                margin-top: 30px;
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #1E2134;
            }
            .dialog-check-pay{
                margin-top: 15px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-end;
                border-radius: 12px;
                border: 1px solid #F9FAFD;
                .dialog-check-pay-left{
                    width: 30%;
                    height: 209px;
                    background: #F9FAFD;
                    border-radius: 12px 0 0 12px;
                    .dialog-check-pay-left-box{
                        // margin-left: 20px;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        padding: 20px 30px;
                        img{
                            width: 30px;
                            height: 30px;
                        }
                        span{
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #1E2134;
                            margin-left: 10px;
                        }
                    }
                }
                .dialog-check-pay-right{
                    width: 70%;
                    height: 209px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .dialog-check-pay-right-pay{
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        img{
                            width: 140px;
                            height: 140px;
                            margin-right: 15px;
                        }
                        .dialog-check-pay-right-pay-phone{
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-items: center;
                            span{
                                &:nth-child(1){
                                    font-size: 14px;
                                    font-family: PingFangSC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #1E2134;
                                }
                                &:nth-child(2){
                                    font-size: 24px;
                                    font-family: SFProDisplay-Semibold, SFProDisplay;
                                    font-weight: 600;
                                    color: #F24342;
                                }
                                &:nth-child(3){
                                    font-size: 14px;
                                    font-family: PingFangSC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #1E2134;
                                }
                            }
                        }
                    }
                    .dialog-check-pay-right-balance{
                        display: flex;
                        flex-direction: column;
                        justify-content: space-evenly;
                        align-items: center;
                        div{
                            &:nth-child(1){
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #1E2134;
                            }
                            &:nth-child(2){
                                display: flex;
                                flex-direction: row;
                                justify-content: flex-start;
                                align-items: center;
                                margin: 24px 0 36px 0;
                                span{
                                    &:nth-child(1){
                                        font-size: 14px;
                                        font-family: PingFangSC-Regular, PingFang SC;
                                        font-weight: 400;
                                        color: #1E2134;
                                    }
                                    &:nth-child(2){
                                        font-size: 24px;
                                        font-family: SFProDisplay-Semibold, SFProDisplay;
                                        font-weight: 600;
                                        color: #F24342;
                                    }
                                    &:nth-child(3){
                                        font-size: 14px;
                                        font-family: PingFangSC-Regular, PingFang SC;
                                        font-weight: 400;
                                        color: #1E2134;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

 .dialog{
        border-radius: 20px;
    }
    .balance{
        width: 100%;
        .balance-num{
            background-image: url(../../../assets/image/balance-bg.png);
            background-repeat: no-repeat;
            background-size: 100%;
            width: 100%;
            height: 142px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .balance-num-item{
                margin-left: 50px;
                margin-bottom: 8px;
                div{
                    &:nth-child(1){
                        font-size: 18px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        margin-bottom: 6px;
                    }
                    &:nth-child(2){
                        font-size: 26px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .input{
            width: 336px;
            margin: 0 auto;
            .el-input__inner{
                width: 336px;
                height: 57px;
                background: #F9FAFD;
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                margin: 0 auto;
                border: none;
            }
        }
        .recharge-type{
            width: 336px;
            margin: 0 auto;
            margin-top: 25px;
            .recharge-type-title{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #1E2134;
            }
            .recharge-type-box{
                margin-top: 20px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 10px 15px;
                border-radius: 6px;
                border: 1px solid #F9FAFD;
                .recharge-type-box-left{
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    img{
                        width: 30px;
                        height: 30px;
                    }
                    span{
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #1E2134;
                        margin-left: 10px;
                    }
                }
                img{
                    width: 18px;
                    height: 18px;
                }
            }
            .active{
                background: #F5FAFE;
                color: #3D7EFF;
            }
        }
        .recharge-btn{
                width: 336px;
                height: 50px;
                margin: 0 auto;
                margin-top: 30px;
                .el-button{
                    width: 336px;
                    height: 50px;
                    margin: 0 auto;
                    background: #3D7EFF;
                    border-radius: 6px;
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }
        }
    }
    .contain-right{
        width: 77%;
        padding: 20px 20px 20px 20px;
        margin-left: 20px;
        .contain-right-menu{
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .contain-right-menu-box{
                cursor: pointer;
                width: 21%;
                padding: 20px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                background: #FFFFFF;
                border-radius: 8px;
                height: 120px;
                .contain-right-menu-box-left{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .balance{
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #858585;
                    }
                    .balance-number{
                        font-size: 20px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #1E2134;
                        margin: 15px 0;
                    }
                    .go-recharge{
                        display: flex;
                        flex-direction: row;
                        justify-content:flex-start;
                        align-items: center;
                        span{
                            font-size: 16px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #3D7EFF;
                        }
                        img{
                            width: 13px;
                            height: 13px;
                            margin-left: 8px;
                        }
                    }
                }
                img{
                    width: 66px;
                    height: 66px;
                }
            }

        }
    }
</style>